const api = {
  // 登录
  login: {
    url: '/login',
    method: 'POST',
  },
  coordinationCentreTradeUserLogin: {
    url: '/tczxUser/coordinationCentreTradeUserLogin',
    method: 'POST',
  },
  // 获取当前登录用户信息
  getUserInfo: {
    url: '/getUserinfo',
    method: 'GET',
  },
  // 供需发布页动态
  getDynamic: {
    url: '/index/dynamic',
    method: 'GET',
  },
  // 供需发布页获取热门商品
  getHotGoods: {
    url: '/supplyAndDemand/getHotGoods',
    method: 'GET',
  },
  selectHotGoodList: {
    url: '/supplyAndDemand/selectHotGoodList',
    method: 'GET',
  },
  selectHotDemandList: {
    url: '/supplyAndDemand/selectHotDemandList',
    method: 'GET',
  },
  // 知识产权专题页 专利精品
  getHotGoodsNew: {
    url: '/activityTopic/getAllRelatedGoodsPage',
    method: 'GET',
  },
  getHotGoodsNewJs: {
    url: '/activityTopic/getAllRelatedGoodsPageJs',
    method: 'GET',
  },
  // 供需发布页获取优质店铺
  getSuperiorShop: {
    url: '/shop/getSuperiorShop',
    method: 'GET',
  },
  // 获取热门需求
  getHotDemand: {
    url: '/supplyAndDemand/getHotDemand',
    method: 'GET',
  },
  // 登出
  signout: {
    url: '/logout',
    method: 'GET',
  },
  getProtocol: {
    // 获取网站相关协议
    url: '/getProtocol',
    method: 'GET',
  },
  // 获取图片验证码
  getCaptchaCode: {
    url: '/getCaptchaCode',
    method: 'GET',
  },
  // 注册校验手机号码是否可用
  isPhoneExist: {
    url: '/isPhoneExist',
    method: 'GET',
  },
  // 获取注册短信验证码,返回发送验证码次数，达到三次则显示图片验证码并校验图片验证码
  getSmsCodeForSignUp: {
    url: '/getSmsCodeForSignUp',
    method: 'GET',
  },
  // 注册
  setPasswordForSignUp: {
    url: '/setPasswordForSignUp',
    method: 'POST',
  },

  // 注册2
  setPasswordForSignUp2: {
    url: '/setPasswordForSignUp2',
    method: 'POST',
  },

  // 校验短信验证码，返回随机验证码，随机验证码用于修改忘记密码
  checkSmsCodeForSignUp: {
    url: '/checkSmsCodeForSignUp',
    method: 'GET',
  },
  // 修改忘记密码，需要调用校验短信验证码后返回的随机码
  changePwdForForgetPwd: {
    url: '/changePwdForForgetPwd',
    method: 'PUT',
  },
  // 搜索
  searchAll: {
    url: '/search/global',
    method: 'POST',
  },
  // 获取热门商品
  topGoodsImagesByHits: {
    url: '/search/topGoodsImagesByHits',
    method: 'POST',
  },
  // 获取热门需求
  topDemandsByHits: {
    url: '/search/topDemandsByHits',
    method: 'POST',
  },
  // 获取热门店铺
  topShopsByHits: {
    url: '/search/topShopByGoodsAmount',
    method: 'GET',
  },
  // 获取商品页详情
  getGoodsInfo: {
    url: '/search/getGoodsInfo',
    method: 'GET',
  },
  // 获取专利开发数据统计
  getTopStatics: {
    url: '/search/getTopStatics',
    method: 'GET',
  },
  // 根据商品id查询联系号码
  getPhoneByGoodsId: {
    url: '/search/getPhoneByGoodsId',
    method: 'GET',
  },
  // 获取需求页详情
  getDetailByDemandId: {
    url: '/search/getDetailByDemandId',
    method: 'GET',
  },
  // 根据需求id查询联系号码
  getPhoneByDemandId: {
    url: '/search/getPhoneByDemandId',
    method: 'GET',
  },
  // 根据店铺id获取店铺详情
  getShopDetailsById: {
    url: '/shop/getShopDetailByShopId',
    method: 'GET',
  },
  // 根据店铺获取热门推荐商品（根据设置热门、发布时间排序）
  getShopPageListOrderByHot: {
    url: '/shop/getShopPageListOrderByHot',
    method: 'GET',
  },
  // 获取（技术、成功、服务）热门推荐的商品
  getThirdShopPageListOrderByHot: {
    url: '/shop/getThirdShopPageListOrderByHot',
    method: 'GET',
  },
  // 根据shopid分页搜索商品
  getGoodsPageListByShopId: {
    url: '/shop/getGoodsPageListByShopId',
    method: 'GET',
  },
  // 根据ID获取资讯详情
  getInformationById: {
    url: '/PortalInformation/getInformationById',
    method: 'GET',
  },
  // 根据分类id分页查询
  getPageInformation: {
    url: '/PortalInformation/getPageInformation',
    method: 'GET',
  },
  // 资讯上半部分
  getTopInformation: {
    url: '/PortalInformation/getTopInformation',
    method: 'GET',
  },
  // 资讯横幅信息获取
  getBannerInformation: {
    url: '/PortalInformation/getBannerInformation',
    method: 'GET',
  },
  // 资讯下半部分
  getTopTypeInformation: {
    url: '/PortalInformation/getTopTypeInformation',
    method: 'GET',
  },
  selectNumInformationListByTypeId: {
    url: '/PortalInformation/selectNumInformationListByTypeId',
    method: 'GET',
  },
  getSmsCodeForForgetPwd: {
    // 获取验证码
    url: '/getSmsCodeForForgetPwd',
    method: 'GET',
  },
  checkSmsCodeForForgetPwd: {
    // 校验验证码
    url: '/checkSmsCodeForForgetPwd',
    method: 'GET',
  },
  applyAgent: {
    // 申请商品代理
    url: '/portalGoodsAgent/applyForAgent',
    method: 'POST',
  },
  getAssociatedGoods: {
    // 查询可撮合的商品
    url: '/search/getAssociatedGoods',
    method: 'GET',
  },
  makeMatch: {
    // 撮合商品
    url: '/search/makeMatch',
    method: 'PUT',
  },
  // 已获身份列表
  identities: {
    url: '/portalGoodsAgent/identities',
    method: 'GET',
  },
  // 获取未读消息数量
  getMessageCount: {
    url: '/portalMessage/getMessageCount',
    method: 'GET',
  },
  // 购买商品
  handlePurchase: {
    url: '/search/handlePurchase',
    method: 'PUT',
  },
  // 收藏商品or需求
  setCollectStatus: {
    url: '/search/setCollectStatus',
    method: 'PUT',
  },
  // 判断商品需求是否收藏
  judgeCollected: {
    url: '/search/judgeCollected',
    method: 'GET',
  },
  // 获取公示详情
  getPublicityDetail: {
    url: '/publicity/getPublicityDetail',
    method: 'GET',
  },
  // 公示列表查询
  getPublicityListingsPage: {
    url: '/publicity/getPublicityListingsPage',
    method: 'GET',
  },
  // 提出异议
  raiseObjections: {
    url: '/publicity/raiseObjections',
    method: 'PUT',
  },
  // 挂牌
  goodsListing: {
    url: '/publicity/goodsListing',
    method: 'GET',
  },
  // 首页新闻公告
  getHomeNews: {
    url: '/PortalInformation/getInformationFour',
    method: 'GET',
  },
  // 首页动态数据
  dynamicSummary: {
    url: '/PortalInformation/selectParam',
    method: 'GET',
  },
  // 广告中心
  getAds: {
    url: '/ads/getAds',
    method: 'GET',
  },
  // 帮助中心-内容-详情查询
  getHelpContent: {
    url: '/helpCentre/getHelpContent',
    method: 'GET',
  },
  // 前台类目树形结构查询
  getHelpCategories: {
    url: '/helpCentre/getHelpCategories',
    method: 'GET',
  },

  // 帮助中心-内容-根据二级类目id分页查询
  getHelpContentsByCategoryChildId: {
    url: '/helpCentre/getHelpContentsByCategoryChildId',
    method: 'GET',
  },
  // 帮助中心-内容-根据标题分页查询
  getHelpContentsByTitle: {
    url: '/helpCentre/getHelpContentsByTitle',
    method: 'GET',
  },
  // 帮助中心首页展示关键词
  selectHelgetHelpKeywordKeyword: {
    url: '/helpCentre/selectHelgetHelpKeywordKeyword',
    method: 'GET',
  },
  // 帮助中心快捷引导二级类目以及内容展示
  getHelpGuideCategoryContents: {
    url: '/helpCentre/getHelpGuideCategoryContents',
    method: 'GET',
  },
  // 获取最新的可下载文件
  getContractTopRecords: {
    url: '/contractRegistration/getTopRegOptionsFile',
    method: 'GET',
  },
  // 获取合同登记的下载列表|使用说明
  getContractSettingList: {
    url: '/contractRegistration/getRegOptionsFileByPage',
    method: 'POST',
  },
  // 获取合同登记的政策法规列表
  getContractLawPolicy: {
    url: '/contractRegistration/getLawAndPolicyListInfo',
    method: 'POST',
  },
  // 获取政策法则列表信息
  getContractLawPolicySticky: {
    url: '/contractRegistration/getLawAndPolicyListSticky',
    method: 'GET',
  },
  // 获取合同登记的通知公告列表
  getContractNotification: {
    url: '/contractRegistration/getNotificationListInfo',
    method: 'POST',
  },
  // 获取合同登记的明细
  getContractById: {
    url: '/contractRegistration/getRegistrationById',
    method: 'GET',
  },
  // 获取合同登记的主推
  getContractMainPush: {
    url: '/contractRegistration/getTopTypeContractRegistration',
    method: 'GET',
  },
  getAppUser: {
    url: '/authorizationLogin/getAppUser',
    method: 'GET',
  },
  getAccessToken: {
    url: '/szkjUser/getAccessToken',
    method: 'GET',
  },
  getSSOUserInfo: {
    url: '/szkjUser/getUserInfo',
    method: 'GET',
  },
  getSmsCodeForAuthorizationLogin: {
    url: '/authorizationLogin/getSmsCodeForAuthorizationLogin',
    method: 'GET',
  },
  bindOpenidByPhone: {
    url: '/authorizationLogin/bindOpenidByPhone',
    method: 'POST',
  },
  // 猜你喜欢的技术成果
  getAchievementById: {
    url: '/search/getAchievementByID',
    method: 'GET',
  },
  // 猜你喜欢的技术成果
  getRecommendTechById: {
    url: '/search/getRecommendTechById',
    method: 'GET',
  },
  // 猜你喜欢的需求
  getRequireById: {
    url: '/search/getRequireByID',
    method: 'GET',
  },
  // 在线评估
  getValueScore: {
    url: '/search/getValueScore',
    method: 'GET',
  },
  getClient: {
    url: '/communication/getClientByUser',
    method: 'GET',
  },
  consultAdmin: {
    url: '/communication/consultAdmin',
    method: 'GET',
  },
  consultShop: {
    url: '/communication/consultShop',
    method: 'GET',
  },
  getMessages: {
    url: '/communication/getMessages',
    method: 'GET',
  },
  upload: {
    url: '/upload',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  },
  deleteVisitor: {
    url: '/communication/deleteVisitor',
    method: 'POST',
  },

  // 商品咨询量+1
  addGoodsInquiries: {
    url: '/search/addGoodsInquiries',
    method: 'PUT',
  },
  getShopDetail: {
    url: '/shop/getShopDetail',
    method: 'GET',
    noNotice: true,
  },
  getClientByShop: {
    url: '/communication/getClientByShop',
    method: 'GET',
  },
  // 活动
  getAdslist: {
    url: '/activity/ads/adslist',
    method: 'GET',
    noNotice: true,
  },
  // 众包获取下一层标签
  getNextTab: {
    url: '/crowdsourceDemand/getDetail',
    method: 'GET',
  },
  // 获取最新启用的版本
  getLastVersion: {
    url: '/crowdsourceDemand/getLastVersion',
    method: 'GET',
  },
  // 获取专家详细信息
  getExpertDetail: {
    url: '/crowdsourceDemand/getExpertDetail',
    method: 'GET',
  },
  // 获取非专家人员详细信息
  getPortalUserById: {
    url: '/crowdsourceDemand/getPortalUserById',
    method: 'GET',
  },
  // 获取人才名单集合
  getTalentsList: {
    url: '/crowdsourceDemand/getTalentsList',
    method: 'GET',
  },
  // 获取用户解决的需求的列表
  getMySolveDemandList: {
    url: '/crowdsourceDemand/getMySolveDemandList',
    method: 'GET',
  },
  // 提交邀约信息
  submitInvite: {
    url: '/crowdsourceDemand/submitInvite',
    method: 'PUT',
  },
  // 技术经理人申诉
  representate: {
    url: '/portalGoodsAgent/representate',
    method: 'PUT',
  },
  // 众包获取需求详情
  getDemandDetail: {
    url: '/crowdsourceDemand/getDemandDetail',
    method: 'GET',
  },
  // 众包获取展示数据
  getDisplayDataInfo: {
    url: '/crowdsourceDemand/getDisplayDataInfo',
    method: 'GET',
  },
  // 获取众包需求分页集合
  getDemandPageList: {
    url: '/crowdsourceDemand/getDemandPageList',
    method: 'GET',
  },
  // 获取众包需求问题信息
  getDemandQuestions: {
    url: '/crowdsourceDemand/getDemandQuestions',
    method: 'GET',
    needStaffId: true,
  },
  // 根据用户名Id获取积分值
  getById: {
    url: '/integral/getById',
    method: 'GET',
  },
  // 查询所有地址
  getAllAddress: {
    url: '/goodsIntegral/getAllAddress',
    method: 'GET',
  },
  // 根据id查询积分商品
  getGoodsById: {
    url: '/goodsIntegral/getById',
    method: 'GET',
  },
  // 分页查询所有积分商品
  getGoodsPageById: {
    url: '/goodsIntegral/getPage',
    method: 'GET',
  },
  // 新增地址
  addAddress: {
    url: '/goodsIntegral/addAddress',
    method: 'POST',
  },
  // 删除地址
  deleteAddressById: {
    url: '/goodsIntegral/deleteById',
    method: 'POST',
  },
  // 修改地址
  updateAddress: {
    url: '/goodsIntegral/updateAddress',
    method: 'POST',
  },
  // 新建积分商品订单
  addOrder: {
    url: '/goodsIntegral/addOrder',
    method: 'PUT',
  },
  // 设置默认地址
  updateAddressStatus: {
    url: '/goodsIntegral/updateAddressStatus',
    method: 'PUT',
  },
  // 分页查询所有兑换记录
  getOrderPage: {
    url: '/goodsIntegral/getOrderPage',
    method: 'GET',
  },
  // 获取关注状态（是否已关注）
  judgeInterest: {
    url: '/shop/judgeInterest',
    method: 'GET',
  },
  // 关注、取消关注
  setInterestStatus: {
    url: '/shop/setInterestStatus',
    method: 'PUT',
  },
  // 获取商品评价列表
  getGoodsRatesById: {
    url: '/search/getGoodsRatesById',
    method: 'GET',
  },
  // 查询所有一级举报类型
  getAllFirstTypes: {
    url: '/goodsReport/getAllFirstTypes',
    method: 'GET',
  },
  // 根据父类id查询所有子类举报类型
  getAllSecondTypesById: {
    url: '/goodsReport/getAllSecondTypesById',
    method: 'GET',
  },
  // 申请商品举报
  applyGoodsReport: {
    url: '/goodsReport/applyGoodsReport',
    method: 'POST',
  },
  // 猜你喜欢-推荐服务
  getRecommandService: {
    url: '/search/getServiceRecommendGoods',
    method: 'GET',
  },
  // 猜你喜欢，根据点击量分页获取需求
  getDemandsPageListOrderHits: {
    url: '/crowdsourceDemand/getDemandsPageListOrderHits',
    method: 'GET',
  },
  getRecommendDemandsList: {
    url: '/crowdsourceDemand/getRecommendDemandsList',
    method: 'GET',
  },
  // 获取MiniProgramCode
  getMiniProgramCode: {
    url: '/crowdsourceDemand/getMiniProgramCode',
    method: 'GET',
  },
  // 提交解决方案
  submitSolution: {
    url: '/crowdsourceDemand/submitSolution',
    method: 'POST',
    needStaffId: true,
  },
  // 查询是否可商品举报
  queryReport: {
    url: '/goodsReport/queryReport',
    method: 'GET',
  },
  // 分页查询所有活动
  getActivities: {
    url: '/activity/activities',
    method: 'GET',
  },
  // 新增活动申请
  activityInsert: {
    url: '/activityApply/insert',
    method: 'POST',
  },
  // 获取审核信息
  getAuditInfo: {
    url: '/account/getAuditInfo',
    method: 'GET',
  },
  // 获取活动专题详情
  getActivityDetail: {
    url: '/activity/activityDetail',
    method: 'GET',
  },
  // 查询众包问题最新动态
  getCrowdSourceDemandSolveDynamic: {
    url: '/crowdsourceDemand/getCrowdSourceDemandSolveDynamic',
    method: 'GET',
  },
  // 用户活动报名
  userInsert: {
    url: '/activitySignUp/insert',
    method: 'POST',
  },
  // 获取活动图片的banner
  getBanners: {
    url: '/activity/getBanners',
    method: 'GET',
  },
  // 修改回答状态
  setAnswerStatus: {
    url: '/crowdsourceDemand/setAnswerStatus',
    method: 'GET',
  },
  // 获取用户审核的众包需求问题信息
  getApplyDemandQuestions: {
    url: '/crowdsourceDemand/getApplyDemandQuestions',
    method: 'GET',
  },
  getExpertRecommend: {
    url: '/crowdsourceDemand/getExpertRecommend',
    method: 'GET',
  },
  // 提交问题反馈
  submitFeedback: {
    url: '/account/submitFeedback',
    method: 'PUT',
  },
  getAntiNcpList: {
    url: '/antiepidemic/achievements',
    method: 'GET',
  },
  getAntiNcpById: {
    url: '/antiepidemic/achievement',
    method: 'GET',
  },
  addAntiNcp: {
    url: '/antiepidemic/addAchievement',
    method: 'POST',
  },
  getProductDetailById: {
    // 获取产品详情
    url: '/product/getProductBySpecId',
    method: 'GET',
  },
  getApplyStatus: {
    // 查看申请状态
    url: '/college/getApplyStatus',
    method: 'GET',
  },
  getForMenus: {
    // 是否开通店铺和身份信息来判断显示的菜单
    url: '/college/getForMenus',
    method: 'GET',
  },
  goToCollege: {
    // 调用此接口，返回一个字符串（collegeLoginToken），然后带上此token请求高校系统自动登陆接口（post/autoLogin）
    url: '/college/goToCollege',
    method: 'GET',
  },
  doMakeMatch: {
    url: '/search/crowdSourceMakeMatch',
    method: 'POST',
  },
  changePassword: {
    // 修改密码
    url: '/account/changePassword',
    method: 'PUT',
  },

  // 根据shopid分页搜索商品 - 2021-08-09 测试添加
  getGoodsPageListsByShopId: {
    url: '/shop/getGoodsPageListsByShopId',
    method: 'GET',
  },

  // 根据shopid分页搜索商品 - 2021-08-09 测试添加(更换)
  getSoleGoods: {
    url: '/shop/getSoleGoods',
    method: 'GET',
  },

  // 根据店铺获取热门推荐商品（根据设置热门、发布时间排序） - 2021-08-09 测试添加
  getShopPageListOrderByHots: {
    url: '/shop/getShopPageListOrderByHots',
    method: 'GET',
  },
  // 公示列表查询 - 2021-08-10 测试添加
  getPublicityListingsPages: {
    url: '/publicity/getPublicityListingsPages',
    method: 'GET',
  },
  // 挂牌 - 2021-08-10 测试添加
  goodsListings: {
    url: '/publicity/goodsListings',
    method: 'GET',
  },

  // 获取热门需求 - 2021-08-10 测试添加
  getHotDemands: {
    url: '/supplyAndDemand/getHotDemands',
    method: 'GET',
  },
  // 获取店铺 相关内容 - 2021-08-12 测试添加
  getPageListByShopId: {
    url: '/shop/getPageListByShopId',
    method: 'GET',
  },
  // 众包需求 - 2021-08-12 测试添加
  getHotDemands2: {
    url: '/supplyAndDemand/getHotDemands2',
    method: 'GET',
  },
  // 根据商铺id获得需求 - 2021-08-13 测试添加
  getDemandById: {
    url: '/supplyAndDemand/getDemandById',
    method: 'GET',
  },

  // 交易公示列表
  // getOrderGoods:{
  //     url: '/publicity/getOrderGoods',
  //     method: 'GET'
  // }

  // 获取所属分中心
  getTenant: {
    url: '/getTenant',
    method: 'PUT',
  },

  // 首页 未来产业,战略信息产业分类标签
  selectSysTags: {
    url: '/themeGoods/selectSysTags',
    method: 'GET',
  },

  selectSysTagsVo: {
    url: '/themeGoods/selectSysTagVo',
    method: 'GET',
  },

  // 战略新兴产业
  getStrategicEmergingIndustries: {
    url: '/themeGoods/selectStrategicEmergingIndustries',
    method: 'POST',
  },

  // 未来产业
  getFutureIndustries: {
    url: '/themeGoods/selectFutureIndustries',
    method: 'POST',
  },

  // 区域成果
  getRegionalAchievements: {
    url: '/themeGoods/selectRegionalAchievements',
    method: 'POST',
  },

  // 商品列表
  getPageThemeGoodsDto: {
    url: '/themeGoods/selectPageThemeGoodsDto',
    method: 'POST',
  },
  // 关联成果
  selectActiveGoodsDto: {
    url: '/activity/selectActiveGoodsDto',
    method: 'GET',
  },
  // 关联需求
  selectActiveDemandsDto: {
    url: '/activity/selectActiveDemandsDto',
    method: 'GET',
  },
  // 热门数据
  selectPopularActivity: {
    url: '/activity/selectPopularActivity',
    method: 'GET',
  },
  // 大院大所 省内高校
  getThemeGoodsInfoByType: {
    url: '/themeGoods/selectThemeGoodsInfoByType',
    method: 'POST',
  },
  // 江苏省科学技术奖成果推荐
  selectGoodsInfoByActiveId: {
    url: '/themeGoods/selectGoodsInfoByActiveId',
    method: 'POST',
  },
  // 获取名称
  getThemeName: {
    url: '/themeGoods/getThemeName',
    method: 'GET',
  },
  // 统计数据
  selectCountInfo: {
    url: '/themeGoods/selectCountInfo',
    method: 'POST',
  },
  // 获取短信验证码
  sendPhoneCode: {
    url: '/sendPhoneCode',
    method: 'GET',
  },
  // 获取短信验证码
  messageLogin: {
    url: '/messageLogin',
    method: 'POST',
  },
  // 校验用户信息完整性
  checkUserInfo: {
    url: '/account/checkUserInfo',
    method: 'POST',
  },
  // 获取banner
  getThemeBanner: {
    url: '/themeGoods/getThemeBanner',
    method: 'GET',
  },
  // 事务所数据
  getFirmList: {
    url: '/themeGoods/selectThemeGoodsInfoByType2',
    method: 'POST',
  },
  // 技术经理人数据
  getTechManagerList: {
    url: '/themeGoods/getThemeSerGroupTechManager',
    method: 'GET',
  },
  getThemeSerGroupTechManager3: {
    url: '/themeGoods/getThemeSerGroupTechManager3',
    method: 'POST',
  },
  getDataDictByCode: {
    url: '/index/getDataDictByCode',
    method: 'GET',
  },
  // 相关文件
  getThemeFile: {
    url: '/themeGoods/getThemeFile',
    method: 'GET',
  },
  pageActivityShop: {
    url: '/commonActivity/pageActivityShop',
    method: 'GET',
  },
  pageActivityShopByXianlin: {
    url: '/commonActivity/pageActivityShopByXianlin',
    method: 'GET',
  },
  // 中介方专区
  getIntermediaryList: {
    url: '/themeGoods/selectPageThemeGoodsDto2',
    method: 'POST',
  },
  // 专利价值评估
  selectPatentEvaluation: {
    url: '/zgData/selectPatentEvaluation',
    method: 'GET',
  },
  // 企业创新能力分析
  selectEnterpriseDetail: {
    url: '/zgData/selectEnterpriseDetail',
    method: 'GET',
  },
  // 企业创新能力分析 标签查询
  selectCompanyDetail: {
    url: '/zgData/selectCompanyDetail',
    method: 'GET',
  },
  // 专利价值分析 功能开关
  selectFunctionSwitch: {
    url: '/zgData/selectFunctionSwitch',
    method: 'GET',
  },
  // 需求专栏 筛选条件
  selectThemeDemandQueryCriteria: {
    url: '/themeDemand/selectThemeDemandQueryCriteria',
    method: 'GET',
  },
  // 需求专栏 分页数据
  selectThemeDemandPageQuery: {
    url: '/themeDemand/selectThemeDemandPageQuery',
    method: 'POST',
  },
  // 需求专栏 需求推荐
  selectThemeDemandRecommendPageQuery: {
    url: '/themeDemand/selectThemeDemandRecommendPageQuery',
    method: 'GET',
  },
  // 需求专栏 最新需求
  selectThemeDemandLatestQuery: {
    url: '/themeDemand/selectThemeDemandLatestQuery',
    method: 'get',
  },
  // 需求统计数据
  selectThemeDemandStatisticsQuery: {
    url: '/themeDemand/selectThemeDemandStatisticsQuery',
    method: 'POST',
  },
  // 需求 获取名称
  selectDemandThemeName: {
    url: '/themeDemand/selectDemandThemeName',
    method: 'GET',
  },
  // 需求 解答榜
  selectThemeDemandAnswerListQuery: {
    url: '/themeDemand/selectThemeDemandAnswerListQuery',
    method: 'POST',
  },
  // 需求 重点企业
  selectThemeDemandKeyEnterprisesQuery: {
    url: '/themeDemand/selectThemeDemandKeyEnterprisesQuery',
    method: 'POST',
  },
  // 需求 省内企业
  selectThemeDemandProvinceQuery: {
    url: '/themeDemand/selectThemeDemandProvinceQuery',
    method: 'POST',
  },
  // 需求 省内企业
  selectThemeDemandResearchInstitutionsQuery: {
    url: '/themeDemand/selectThemeDemandResearchInstitutionsQuery',
    method: 'POST',
  },
  // 需求 区域需求
  selectThemeDemandRegionQuery: {
    url: '/themeDemand/selectThemeDemandRegionQuery',
    method: 'GET',
  },
  // 需求 战略新兴产业
  selectStrategicEmergingIndustries: {
    url: '/themeDemand/selectStrategicEmergingIndustries',
    method: 'GET',
  },
  // 需求 未来产业
  selectFutureIndustries: {
    url: '/themeDemand/selectFutureIndustries',
    method: 'GET',
  },
  // 活动 路演推荐
  roadShowRecommend: {
    url: '/activity/roadShowRecommend',
    method: 'GET',
  },
  // 活动 活动推荐
  activitiesRecommend: {
    url: '/activity/activitiesRecommend',
    method: 'GET',
  },
  selectThemeGoodRecommendPageQuery: {
    url: '/themeGoods/selectThemeGoodRecommendPageQuery',
    method: 'get',
  },
  // 需求专栏 最新需求
  selectThemeGoodLatestQuery: {
    url: '/themeGoods/selectThemeGoodLatestQuery',
    method: 'GET',
  },
  selectDemandOverallTechnologyList: {
    url: '/crowdsourceDemand/selectDemandOverallTechnologyList',
    method: 'GET',
  },
  // 伊犁
  selectDemandOverallTechnologyListYili: {
    url: '/activityThemePage/selectDemandOverallTechnologyList',
    method: 'GET',
  },
  demandOverallPublish: {
    // 统筹需求发布
    url: '/crowdsourceDemand/demandOverallPublish',
    method: 'POST',
  },
  selectPageOverallDemandDtoList: {
    url: '/crowdsourceDemand/selectPageOverallDemandDtoList',
    method: 'POST',
  },
  selectOverallDemandDtoList: {
    url: '/crowdsourceDemand/selectOverallDemandDtoList',
    method: 'POST',
  },
  selectOverallDemandDynamicsList: {
    url: '/crowdsourceDemand/selectOverallDemandDynamicsList',
    method: 'POST',
  },
  selectActivityEventSite: {
    //  活动现场
    url: '/activity/selectActivityEventSite',
    method: 'GET',
  },
  getTopInformation2: {
    //
    url: '/PortalInformation/getTopInformation2',
    method: 'GET',
  },
  getInformationFour2: {
    //
    url: '/PortalInformation/getInformationFour2',
    method: 'GET',
  },
  getPageInformations: {
    //
    url: '/PortalInformation/getInformationDto',
    method: 'POST',
  },
  selectOverallActivityPicture: {
    //
    url: '/activityThemePage2/selectOverallActivityPicture',
    method: 'get',
  },
  selectLaSaThemeDemandDtoList: {
    // 拉萨需求列表
    url: '/activityThemePage/selectLaSaThemeDemandDtoList',
    method: 'post',
  },
  selectLaSaThemeDemandDtoListByDS: {
    // 拉萨需求列表
    url: '/activityThemePage/selectLaSaThemeDemandDtoListByDS',
    method: 'post',
  },
  selectLaSaThemeGoodCount: {
    // 拉萨专题页看板
    url: '/activityThemePage/selectLaSaThemeGoodCount',
    method: 'post',
  },
  selectLaSaThemeDemandCount: {
    // 拉萨专题页看板
    url: '/activityThemePage/selectLaSaThemeDemandCount',
    method: 'post',
  },
  selectThemePageConfActivityId: {
    // 获取活动 Id
    url: '/activityThemePage/selectThemePageConfActivityId',
    method: 'get',
  },
  selectLaSaThemeGoodDtoList: {
    // 商品列表查询
    url: '/activityThemePage/selectLaSaThemeGoodDtoList',
    method: 'post',
  },
  selectLaSaThemeGoodDtoListByDS: {
    // 商品列表查询
    url: '/activityThemePage/selectLaSaThemeGoodDtoListByDS',
    method: 'post',
  },
  selectLaSaThemeActivityCount: {
    // 统计
    url: '/activityThemePage/selectLaSaThemeActivityCount',
    method: 'get',
  },

  selectActivityThemeInformationDtoList: {
    // 资讯
    url: '/activityThemePage2/selectActivityThemeInformationDtoList',
    method: 'get',
  },
  selectActivityThemeInformationDtoList2: {
    // 资讯
    url: '/activityThemePage/selectActivityThemeInformationDtoList2',
    method: 'get',
  },
  selectActivityThemeInformationDtoListForUniversity: {
    // 资讯
    url: '/activityThemePage2/selectActivityThemeInformationDtoListForUniversity',
    method: 'POST',
  },
  //
  selectPageLaSaThemeDemandDtoList: {
    // 需求分页列表
    url: '/activityThemePage/selectPageLaSaThemeDemandDtoList',
    method: 'post',
  },
  selectPageDemandDtoListBySubCenter: {
    // 需求分页列表
    url: '/activityThemePage/selectPageDemandDtoListBySubCenter',
    method: 'post',
  },
  lasaselectActivityEventSite: {
    // 现场活动
    url: '/activityThemePage2/selectActivityEventSite',
    method: 'get',
  },
  selectActivityThemeInformationPageDtoList: {
    // 资讯分页列表
    url: '/activityThemePage2/selectActivityThemeInformationPageDtoList',
    method: 'post',
  },
  selectActivityThemeInformationType: {
    // 资讯分类接口
    url: '/activityThemePage2/selectActivityThemeInformationType',
    method: 'get',
  },
  selectPageLaSaThemeGoodDtoList: {
    // 商品列表
    url: '/activityThemePage/selectPageLaSaThemeGoodDtoList',
    method: 'post',
  },
  selectPageGoodDtoListBySubCenter: {
    // 商品列表
    url: '/activityThemePage/selectPageGoodDtoListBySubCenter',
    method: 'post',
  },
  selectPageThemeGoodDtoList: {
    // new商品列表
    url: '/activityThemePage/selectPageThemeGoodDtoList',
    method: 'post',
  },
  selectPublicityInfoCount: {
    // 公式数量和公式金额
    url: '/publicity/selectPublicityInfoCount',
    method: 'get',
  },
  selectGoodListingCount: {
    // 公式数量和公式金额
    url: '/publicity/selectGoodListingCount',
    method: 'get',
  },
  cacheLaSaCookie: {
    // 标记用户访问过拉萨首页
    url: '/activityThemePage/cacheLaSaCookie',
    method: 'post',
  },
  selectHomePageActivityId: {
    // 查询用户访问历史
    url: '/activityThemePage/selectHomePageActivityId',
    method: 'post',
  },
  deleteLaSaCookie: {
    // 清除访问历史
    url: '/activityThemePage/deleteLaSaCookie',
    method: 'post',
  },
  statisticsData: {
    // 供需发布数据看板
    url: '/supplyAndDemand/statisticsData',
    method: 'get',
  },
  selectQualityShopPage: {
    // 查询优质店铺数据
    url: '/supplyAndDemand/selectQualityShopPage',
    method: 'get',
  },
  selectQualityDemandList: {
    // 查询优质需求数据
    url: '/supplyAndDemand/selectQualityDemandList',
    method: 'POST',
  },
  selectQualityGoodList: {
    // 查询优质商品数据
    url: '/supplyAndDemand/selectQualityGoodList',
    method: 'POST',
  },
  insertUserSubmitProblem: {
    // 专家咨询
    url: '/userExpertConsultation/insertUserSubmitProblem',
    method: 'POST',
  },
  selectFollowExpertStatus: {
    // 查询是否关注
    url: '/userExpertConsultation/selectFollowExpertStatus',
    method: 'GET',
  },
  selectLikeExpertStatus: {
    // 查询是否点赞
    url: '/userExpertConsultation/selectLikeExpertStatus',
    method: 'GET',
  },
  followExpert: {
    // 关注
    url: '/userExpertConsultation/followExpert',
    method: 'GET',
  },
  unfollowExpert: {
    // 取消关注
    url: '/userExpertConsultation/unfollowExpert',
    method: 'GET',
  },
  likeExpert: {
    // 关注
    url: '/userExpertConsultation/likeExpert',
    method: 'GET',
  },
  cancelLikeExpert: {
    // 取消关注
    url: '/userExpertConsultation/cancelLikeExpert',
    method: 'GET',
  },
  selectUserConsultationCount: {
    // 专家点赞量
    url: '/userExpertConsultation/selectUserConsultationCount',
    method: 'GET',
  },
  userResourceDistribution: {
    // 交易数据大屏-用户资源分布
    url: '/open/userResourceDistribution',
    method: 'POST',
  },
  areaResourceDistribution: {
    // 交易数据大屏-用户资源分布
    url: '/open/areaResourceDistribution',
    method: 'POST',
  },
  TechnologyArea: {
    // 领域资源分布
    url: '/open/fieldResourceDistribution',
    method: 'POST',
  },
  tradeDataAggregateData: {
    // 交易数据大屏-汇总数据
    url: '/open/tradeDataAggregateData',
    method: 'POST',
  },
  overallTradeAnalysis: {
    // 交易数据大屏-总体交易分析
    url: '/open/overallTradeAnalysis',
    method: 'POST',
  },
  activityTradeAnalysis: {
    // 交易数据大屏-活动交易分析
    url: '/open/activityTradeAnalysis',
    method: 'POST',
  },
  tradePriceRangeAnalysis: {
    // 交易数据大屏-交易价格区间分析
    url: '/open/tradePriceRangeAnalysis',
    method: 'POST',
  },
  tradeModeAnalysis: {
    // 交易数据大屏-交易方式分析
    url: '/open/tradeModeAnalysis',
    method: 'POST',
  },
  tradeTypeAnalysis: {
    // 交易数据大屏-交易类型分析
    url: '/open/tradeTypeAnalysis',
    method: 'POST',
  },
  selectServiceTypeList: {
    // 查询服务类型
    url: '/serviceTypeConf/selectServiceTypeList',
    method: 'GET',
  },
  queryServiceTypeRecordList: {
    // 查询服务记录列表
    url: '/serviceTypeConf/queryServiceTypeRecordList',
    method: 'POST',
  },
  selectUserExpertTalentThemePage: {
    // 人才专场 专家列表
    url: '/userExpertConsultation/selectUserExpertTalentThemePage',
    method: 'POST',
  },
  // 咨询动态
  selectUserExpertConsultationPage2: {
    url: '/userExpertConsultation/selectUserExpertConsultationPage2',
    method: 'POST',
  },
  // 对接动态
  selectExpertDockingDynamicDtoList: {
    url: '/userExpertConsultation/selectExpertDockingDynamicDtoList',
    method: 'GET',
  },
  // 对接动态
  selectOneUserExpertTalentTheme: {
    url: '/userExpertConsultation/selectOneUserExpertTalentTheme',
    method: 'GET',
  },
  // 专家技术领域
  selectExportTechnologyDtoList: {
    url: '/userExpertConsultation/selectExportTechnologyDtoList',
    method: 'GET',
  },
  // 第三方登录
  thirdUserAuthorize: {
    url: '/thirdLoginUser/thirdUserAuthorize',
    method: 'POST',
  },
  selectThirdUserLogin: {
    url: '/thirdLoginUser/selectThirdUserLogin',
    method: 'POST',
  },
  // --交易数据大屏-获取当前用户城市权限
  /**
     *  private Long adminUserId; // 管理员用户ID
     private String selectType; // 01 查询地区 02 查询分中心 03 查询高校 04 查询领域 05 查询园区
     private String selectYear;
     */
  selectProvinceByUserId: {
    url: '/technologyTrade/selectProvinceByUserId',
    method: 'POST',
  },
  // --交易数据大屏-各个城市汇总数据-中间最上
  tradeDataCityAggregateTradeData: {
    url: '/technologyTrade/tradeDataCityAggregateTradeData',
    method: 'POST',
  },
  // 地区、领域-需求&商品-总体交易分析-中下
  selectTradeYearTrade: {
    url: '/technologyTrade/selectTradeYearTrade',
    method: 'POST',
  },
  // --地区、领域-需求-价格区间-右边最上
  selectTradePriceType: {
    url: '/technologyTrade/selectTradePriceType',
    method: 'POST',
  },
  // 地区-需求&商品-领域成交-右中
  selectTradeTechnologyTrade: {
    url: '/technologyTrade/selectTradeTechnologyTrade',
    method: 'POST',
  },
  // 地区、领域-技术经理人&服务机构数据-右下
  selectTradeService: {
    url: '/technologyTrade/selectTradeService',
    method: 'POST',
  },
  // 地区、领域-需求&商品-发布数排行榜-左上
  selectTradePublishNum: {
    url: '/technologyTrade/selectTradePublishNum',
    method: 'POST',
  },
  // 地区-需求&商品-领域发布-左中
  selectTradeTechnologyPublish: {
    url: '/technologyTrade/selectTradeTechnologyPublish',
    method: 'POST',
  },
  // 地区、领域-需求&商品-交易类型分析-左下
  selectTradeTradeType: {
    url: '/technologyTrade/selectTradeTradeType',
    method: 'POST',
  },
  // 交易数据大屏-获取当前用户领域权限
  selectTechnologyByUserId: {
    url: '/technologyTrade/selectTechnologyByUserId',
    method: 'POST',
  },
  // 园区-交易动态-中下
  selectParkTradingDynamics: {
    url: '/technologyTrade/selectParkTradingDynamics',
    method: 'POST',
  },
  // 园区-需求&商品-合作方式分析-左下
  selectParkTradeTradeType: {
    url: '/technologyTrade/selectParkTradeTradeType',
    method: 'POST',
  },
  // 领域 园区 高校
  tradeDataCityAggregateData: {
    url: '/technologyTrade/tradeDataCityAggregateData',
    method: 'POST',
  },
  // // 园区-需求&商品-合作方式分析-左下
  // selectParkTradeTradeType: {
  //     url: '/technologyTrade/selectParkTradeTradeType',
  //     method: 'POST'
  // },
  // 高校-发布单位交易排行榜-左上
  selectPublishUnitTradeNum: {
    url: '/technologyTrade/selectPublishUnitTradeNum',
    method: 'POST',
  },
  // 领域、高校-交易动态-中下
  selectGoodTechnologyTradingDynamics: {
    url: '/technologyTrade/selectGoodTechnologyTradingDynamics',
    method: 'POST',
  },
  // 高校-交易方式-右上
  selectGoodTechnologyTradeType: {
    url: '/technologyTrade/selectGoodTechnologyTradeType',
    method: 'POST',
  },
  // 领域-各地市需求发布数据-右上
  selectTechnologyPublishNum: {
    url: '/technologyTrade/selectTechnologyPublishNum',
    method: 'POST',
  },
  selectCollegeTradeTechnologyTrade: {
    url: '/technologyTrade/selectCollegeTradeTechnologyTrade',
    method: 'POST',
  },
  // // 01 查询地区 02 查询分中心 03 查询高校 04 查询领域 05 查询园区
  selectTradeScreenSelectorVo: {
    url: '/technologyTrade/selectTradeScreenSelectorVo',
    method: 'POST',
  },
  // 店铺列表
  getShopPageListByActivityId: {
    url: '/shop/getShopPageListByActivityId',
    method: 'GET',
  },
  // 店铺列表
  getShopPageListByActivityIdByXianlin: {
    url: '/shop/getShopPageListByActivityIdByXianlin',
    method: 'GET',
  },
  // 商品发布分页查询
  pageThemeGoodDtoList: {
    url: '/commonActivity/pageThemeGoodDtoList',
    method: 'POST',
  },
  // 商品发布分页查询
  pageThemeGoodDtoListByXianlin: {
    url: '/commonActivity/pageThemeGoodDtoListByXianlin',
    method: 'POST',
  },
  // 店铺详情
  getShopDetailByShopId: {
    url: '/shop/getShopDetailByShopId',
    method: 'GET',
  },
  // 金融专题页-金融专栏-统计
  selectThemeFinancingColumn: {
    url: '/themeFinancing/selectThemeFinancingColumn',
    method: 'GET',
  },
  // 金融专题页-科技金融产品查询
  selectThemeFinancingProduct: {
    url: '/themeFinancing/selectThemeFinancingProduct',
    method: 'GET',
  },
  // 金融专题页-最新需求查询
  selectThemeFinancingLatestDemand: {
    url: '/themeFinancing/selectThemeFinancingLatestDemand',
    method: 'GET',
  },
  // 产品详情
  selectOneThemeFinancingProduct: {
    url: '/themeFinancing/selectOneThemeFinancingProduct',
    method: 'GET',
  },

  // 高校资源数据统计
  getGxIndexNum: {
    url: '/gx/getGxIndexNum',
    method: 'GET',
  },
  // 高校资源数据统计
  getGxIndexNumBySubCenter: {
    url: '/gx/getGxIndexNumBySubCenter',
    method: 'GET',
  },

  // 竞价(拍卖)列表
  getAllTarget: {
    url: '/tradingHall/getAllTarget',
    method: 'GET',
  },

  /**
   * 计量字典表查询
   * dictType：technology_type（技术领域）、area_code（所属区域）、technology_cluster（产业集群)
   */
  getDictList: {
    url: '/measure/getDictList',
    method: 'GET',
  },

  // 计量资源数据统计 /portal/measure/selectMeasureResourceStatistics
  selectMeasureResourceStatistics: {
    url: '/measure/selectMeasureResourceStatistics',
    method: 'GET',
  },

  // 计量首页 平台载体
  listMeasurePlatformForType: {
    url: '/measurePlatform/listMeasurePlatformForType',
    method: 'GET',
  },

  // 计量平台载体列表
  getMeasurePlatformPage: {
    url: '/measurePlatform/getMeasurePlatformPage',
    method: 'POST',
  },

  // 计量测试仪器设备
  getMeasureInstrumentpage: {
    url: '/measureInstrument/getMeasureInstrumentpage',
    method: 'POST',
  },

  // 计量测试仪器设备详情
  selectMeasureInstrumentById: {
    url: '/measureInstrument/selectMeasureInstrumentById',
    method: 'GET',
  },

  // 计量实验室 /measureLaboratory/getMeasureLaboratoryPage
  getMeasureLaboratoryPage: {
    url: '/measureLaboratory/getMeasureLaboratoryPage',
    method: 'POST',
  },
  // 计量实验室详情 /measureLaboratory/selectMeasureLaboratoryById
  selectMeasureLaboratoryById: {
    url: '/measureLaboratory/selectMeasureLaboratoryById',
    method: 'GET',
  },
  // 计量实验室 首页 各类型查询
  listMeasureLaboratoryForType: {
    url: '/measureLaboratory/listMeasureLaboratoryForType',
    method: 'GET',
  },
  // 计量研究成果 -- 先进技术测量
  getTechnologyPageListByOrgId: {
    url: '/measure/getTechnologyPageListByOrgId',
    method: 'GET',
  },

  // 计量研究成果 -- 计量技术规范
  getSpecificationPageListByOrgId: {
    url: '/measure/getSpecificationPageListByOrgId',
    method: 'GET',
  },

  // 计量成功案例
  getMeasureCasepage: {
    url: '/measureCase/getMeasureCasepage',
    method: 'GET',
  },

  // 计量专家人才 -- 弃用
  getMeasureProfessorpage: {
    url: '/measureProfessor/getMeasureProfessorpage',
    method: 'POST',
  },
  // 计量专家人才详情 -- 弃用
  selectMeasureProfessorById: {
    url: '/measureProfessor/selectMeasureProfessorById',
    method: 'GET',
  },
  // 计量专家人才
  selectTalentProfessorPageDto: {
    url: '/measure/selectTalentProfessorPageDto',
    method: 'GET',
  },
  // 计量专家人才详情
  selectOneTalentProfessorDto: {
    url: '/measure/selectOneTalentProfessorDto',
    method: 'GET',
  },
  // 需求分享数+1
  updateDemandShareNum: {
    url: '/crowdsourceDemand/shareCrowdsourceDemandAddCount',
    method: 'PUT',
  },
  // 商品分享数+1
  updateGoodsShareNum: {
    url: '/search/addGoodsShare',
    method: 'PUT',
  },
  // 店铺分享数+1
  updateShopShareNum: {
    url: '/shop/shareShopAddCount',
    method: 'PUT',
  },
  // AI 聊天
  chatMessages: {
    url: '/dify/chatMessages',
    method: 'POST',
    // method: 'GET',
  },
  // 历史记录
  getHistoryList: {
    url: '/dify/getMessages',
    // url: '/dify/getHistoryList',
    method: 'POST',
  },
  // 历史会话id
  getConversations: {
    url: '/dify/getConversations',
    // url: '/dify/getHistoryList',
    method: 'POST',
  },
  // 记录详情
  getMessiagesAi: {
    url: '/dify/getMessages',
    method: 'GET',
  },
  getDifyConfig: {
    url: '/dify/getDifyConfig',
    method: 'GET',
  },
  // 保存搜索关键词
  saveKeywords: {
    url: '/dify/saveKeywords',
    // url: '/dify/getHistoryList',
    method: 'POST',
  },
  // 添加对话标题
  renameConversation: {
    url: '/dify/renameConversation',
    method: 'POST',
  },
  getAssetThemeGoodQuery: {
    // 资产单例专题页商品查询
    url: '/themeGoods/getAssetThemeGoodQuery',
    method: 'GET',
  },
  getPublicityListingsPageByActivity: {
    // 资产单例专题页公示x协议查询
    url: '/publicity/getPublicityListingsPageByActivity',
    method: 'GET',
  },
  getAssetGoodsListing: {
    // 资产单例专题页挂牌查询
    url: '/publicity/getAssetGoodsListing',
    method: 'GET',
  },
  getGoodsSoldGoods: {
    // 资产单例专题页交易公告
    url: '/goodsSold/goods',
    method: 'GET',
  },
  // 先使用后付费专题数据
  selectGoodsInfoByFirstUse: {
    url: '/themeGoods/selectGoodsInfoByFirstUse',
    method: 'POST',
  },
  // 资产单例专题页交易公告
  getSuccessGoods: {
    url: '/goodsSold/successGoods',
    method: 'GET',
  },
  getPatentValue: {
    url: '/search/getPatentValue',
    method: 'GET',
  },
  // xianlin
  pageThemeDemandDtoList: {
    // 需求分页列表
    url: '/commonActivity/pageThemeDemandDtoList',
    method: 'post',
  },
  pageThemeDemandDtoListByXianlin: {
    // 需求分页列表
    url: '/commonActivity/pageThemeDemandDtoListByXianlin',
    method: 'post',
  },
  getTechManager: {
    // 技术经理人列表
    url: '/commonActivity/getTechManager',
    method: 'post',
  },
  pageActivity: {
    // 分页获取活动列表
    url: '/commonActivity/pageActivity',
    method: 'post',
  },
  getActivityById: {
    // 根据活动ID查询活动
    url: '/commonActivity/getActivityById',
    method: 'GET',
  },
  pageOrganization: {
    // 分页查询专业机构
    url: '/commonActivity/pageOrganization',
    method: 'post',
  },
  pageOrganizationYZ: {
    // 分页查询专业机构 --扬州
    url: '/commonActivity/pageOrganizationByNew',
    method: 'post',
  },
  pageUserIdentityByType: {
    // 分页查询用户身份
    url: '/commonActivity/pageUserIdentityByType',
    method: 'post',
  },
  // 项目热度排名(TOP30)
  selectTechnicalManagerProjectPopularityRanking: {
    url: '/activityThemePage3/selectTechnicalManagerProjectPopularityRanking',
    method: 'POST',
  },
  // 项目参赛人数分布
  selectTechnicalManagerProjectParticipantDistribution: {
    url: '/activityThemePage3/selectTechnicalManagerProjectParticipantDistribution',
    method: 'POST',
  },
  // 项目征集数据量分布
  selectTechnicalManagerProjectDataVolumeDistribution: {
    url: '/activityThemePage3/selectTechnicalManagerProjectDataVolumeDistribution',
    method: 'POST',
  },
  // 需求  服务
  demandServiceClick: {
    url: '/activityThemePage3/demandServiceClick',
    method: 'GET',
  },
  // 商品  服务
  goodsServiceClick: {
    url: '/activityThemePage3/goodsServiceClick',
    method: 'GET',
  },
  // 技术经理人
  selectThemeSerGroupTechManager4: {
    url: '/activityThemePage3/selectThemeSerGroupTechManager4',
    method: 'post',
  },
  // 技术经理人活动  经理人列表
  selectThemeSerGroupTechManager5: {
    url: '/activityThemePage3/selectThemeSerGroupTechManager5',
    method: 'post',
  },
  selectUserDemandServicePageDto: {
    url: '/activityThemePage3/selectUserDemandServicePageDto2',
    method: 'post',
  },
  selectUserGoodsServicePageDto: {
    url: '/activityThemePage3/selectUserGoodsServicePageDto2',
    method: 'post',
  },
  // 分页查询分中心需求
  pageHotDemandList: {
    url: '/supplyAndDemand/pageHotDemandList',
    method: 'POST',
  },
  pageTagDemandList: {
    url: '/supplyAndDemand/pageTagDemandList',
    method: 'POST',
  },
  // 分页查询分中心成果
  pageHotGoodList: {
    url: '/supplyAndDemand/pageHotGoodList',
    method: 'POST',
  },
  pageTagGoodList: {
    url: '/supplyAndDemand/pageTagGoodList',
    method: 'POST',
  },
  // 获取广告
  pageAds: {
    url: '/ads/pageAds',
    method: 'GET',
  },
  // 我的问题
  selectPageMyJlProblemDtoList: {
    url: '/JlProblem/selectPageMyJlProblemDtoList',
    method: 'post',
  },
  // 提问
  insertMyJlProblem: {
    url: '/JlProblem/insertMyJlProblem',
    method: 'post',
  },
  // 修改提问
  updateMyJlProblem: {
    url: '/JlProblem/updateMyJlProblem',
    method: 'post',
  },
  // 详情
  getMyJlProblemById: {
    url: '/JlProblem/getMyJlProblemById',
    method: 'get',
  },
  // 服务专区
  pageCenterOrg: {
    url: '/commonActivity/pageCenterOrg',
    method: 'post',
  },
  // 服务专区详情
  getCenterOrgById: {
    url: '/commonActivity/getCenterOrgById',
    method: 'post',
  },
  // 服务专区详情
  activityTechBM: {
    url: '/activityThemePage3/compete',
    method: 'get',
  },
  selectIdentityRecordList: {
    url: '/dify/selectIdentityRecordList',
    method: 'get',
  },
  // AI 建议问题
  suggested: {
    url: '/dify/suggested',
    method: 'post',
  },
  // AI 点赞
  feedbacks: {
    url: '/dify/feedbacks',
    method: 'post',
  },
  // AI 删除历史会话
  deleteConversation: {
    url: '/dify/deleteConversation',
    method: 'post',
  },
  // 扬州 数据概览
  selectCityDataAggregateTradeData: {
    url: '/technologyTrade/selectCityDataAggregateTradeData',
    method: 'POST',
  },
  // 扬州 技术经理人分布
  selectTechnologyRegionNum: {
    url: '/technologyTrade/selectTechnologyRegionNum',
    method: 'POST',
  },
  // 扬州 服务机构分布
  selectServiceUnitRegionNum: {
    url: '/technologyTrade/selectServiceUnitRegionNum',
    method: 'POST',
  },
  // 扬州 提交解决方案数量
  selectDemandAnswerNumTop: {
    url: '/technologyTrade/selectDemandAnswerNumTop',
    method: 'POST',
  },
  // 扬州 技术领域分布
  selectTechnologyFieldNum: {
    url: '/technologyTrade/selectTechnologyFieldNum',
    method: 'POST',
  },
  // 活动列表
  selectBranchCenterActivityList: {
    url: '/activity/selectBranchCenterActivityList',
    method: 'GET',
  },
  // 产业集群枚举
  queryNextLevelTag: {
    url: '/conf/sysTag/queryNextLevelTag',
    method: 'GET',
  },
  bindSzkjAccount: {
    url: '/szkjUser/bindSzkjAccount',
    method: 'POST',
  },
  // 伊犁高校专区
  selectIdentityTypeUserShopPage: {
    url: '/activityThemePage3/selectIdentityTypeUserShopPage',
    method: 'POST',
  },
  // 伊犁数据概览
  selectYiLiStatisticsData: {
    url: '/activityThemePage3/selectYiLiStatisticsData',
    method: 'get',
  },
  // 获取全部政策
  getPolicyList: {
    url: '/search/getPolicyList',
    method: 'GET',
  },
  // 招行提交授权报名
  createUniversityTalentCredit: {
    url: '/universityCredit/createUniversityTalentCredit',
    method: 'POST',
  },
  // 用户招行提交授权报名
  getUniversityTalentCreditByUserId: {
    url: '/universityCredit/getUniversityTalentCreditByUserId',
    method: 'GET',
  },
  // 验证数字科技是否登录
  checkLogin: {
    url: '/szkjUser/checkLogin',
    method: 'GET',
  },
  // 通过token获取数字科技用户信息
  getSzkjUserInfoByToken: {
    url: '/szkjUser/getSzkjUserInfoByToken',
    method: 'GET',
  },
  selectUserIdentityDtoList: {
    url: '/userIdentity/selectUserIdentityDtoList',
    method: 'POST',
  },
  selectServiceFieldList: {
    url: '/conf/sysTag/selectServiceFieldList',
    method: 'get',
  },
  // 公共成果列表
  selectPageThemeGoodsDto: {
    url: '/commonGood/selectPageThemeGoodsDto',
    method: 'POST',
  },
  // 公共需求列表
  selectThemeDemandPageQueryV2: {
    url: '/commonDemand/selectThemeDemandPageQuery',
    method: 'POST',
  },

  // 技术经理人详情
  selectTechnicalManagerDetail: {
    url: '/userIdentity/selectTechnicalManagerDetail',
    method: 'POST',
  },
  // 商品列表
  selectTechnicalManagerGoodList: {
    url: '/userIdentity/selectTechnicalManagerGoodList',
    method: 'POST',
  },
  // 需求列表
  selectTechnicalManagerDemandList: {
    url: '/userIdentity/selectTechnicalManagerDemandList',
    method: 'POST',
  },
  // 机构详情
  selectUserIdentityShopDto: {
    url: '/userIdentity/selectUserIdentityShopDto',
    method: 'POST',
  },
};

export default api;
